import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/hirefit-b2b/hirefit-b2b/src/app/kolleno/senior-backend-developer/ClientPage.tsx");
